/**
 *  @class
 *  @function CartDiscounts
 */
if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.discounts();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    discounts() {
      const button = this.querySelector('.cart-discounts--button');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove')

      if (!button) {
        return;
      }
      button.addEventListener('click', (event) => {
        event.preventDefault();
        button.classList.add('loading');
        this.updateDiscount();
      });
      remove_discount_buttons.forEach((remove_discount_button) => {
        remove_discount_button.addEventListener('click', this.removeDiscount.bind(this));
      });
    }
    updateDiscount() {
      const discountCode = this.querySelector('.cart-discounts--input');
      const discountCodeValue = discountCode.value.trim();
      if (!discountCodeValue) return;

      const existingDiscounts = this.existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;
      existingDiscounts.push(discountCodeValue);

      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }
    removeDiscount(event) {
      const button = event.currentTarget || event.target.closest('.cart-discounts--remove');
      if (!button) return;

      const row = button.closest('.cart-discounts--row');
      const pill = row?.querySelector('.cart-discounts--name');
      if (!pill) return;

      const discountCode = pill.innerHTML;
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.renderDiscounts(existingDiscounts);
    }
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        discountCodes.push(pill.innerHTML);
      }

      return discountCodes;
    }
    hideError() {
      const errorEl = this.querySelector('.cart-discounts--error');
      if (errorEl) errorEl.setAttribute('hidden', '');
    }
    showError() {
      const errorEl = this.querySelector('.cart-discounts--error');
      if (errorEl) errorEl.removeAttribute('hidden');
    }
    discountCodeWasApplied(parsedState, discountCodeValue) {
      if (!discountCodeValue) return false;
      const appliedDiscounts = parsedState.discount_codes || [];
      return appliedDiscounts.some((discount) => discount.code?.toLowerCase() === discountCodeValue.toLowerCase() && discount.applicable !== false);
    }
    renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      this.hideError();
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Unable to update cart discounts.');
          }
          return response.json();
        })
        .then((parsedState) => {
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          const buttonEl = this.querySelector('.cart-discounts--button');
          if (buttonEl) buttonEl.classList.remove('loading');

          if (discountCodeValue && !this.discountCodeWasApplied(parsedState, discountCodeValue)) {
            this.showError();
            return;
          }

          try {
            const drawer = document.getElementById('Cart-Drawer');
            if (drawer) {
              const details = drawer.querySelector('details');
              if (details) details.open = true;

              const cartDiscountsEl = drawer.querySelector('cart-discounts') || drawer.querySelector('.cart-discounts');
              if (cartDiscountsEl && existingDiscounts && existingDiscounts.length) {
                cartDiscountsEl.querySelectorAll('.cart-discounts--row').forEach((r) => r.remove());

                const rowsHtml = existingDiscounts.map(code => `\n                  <div class="cart-discounts--row">\n                    <div><span class="cart-discounts--name">${code}</span><button type="button" class="cart-discounts--remove">✕</button></div>\n                    <span class="price"><span class="amount"></span></span>\n                  </div>`).join('');

                const inner = cartDiscountsEl.querySelector('.cart-discounts--inner');
                if (inner) {
                  inner.insertAdjacentHTML('afterend', rowsHtml);
                } else {
                  cartDiscountsEl.insertAdjacentHTML('beforeend', rowsHtml);
                }

                this.discounts();
              }
            }
          } catch (e) {
            console.error('Cart-discounts: failed to inject client-side discount rows', e);
          }
        })
        .catch(() => {
          const buttonEl = this.querySelector('.cart-discounts--button');
          if (buttonEl) buttonEl.classList.remove('loading');
          this.showError();
        });
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
}